import React from "react";
import {
  CircularProgress,
  Grid,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormGroup,
  Box,
  Paper,
  Divider,
  Chip,
  FormHelperText,
  TableContainer,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ReactComponent as AddIcon } from "Assets/Icons/AddIcon.svg";
import { ReactComponent as EditIconTwo } from "Assets/Icons/EditIconTwo.svg";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import clsx from "clsx";
import DrugAutoComplete from "Components/Patients/DrugAutoComplete";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Button from "Components/Common/Button/Button";

import useViewport from "Hooks/useViewport";

import { useSelector } from "react-redux";
import PharmacyAutoComplete from "Components/Patients/PharmacyAutoComplete";
import SurgeryAutoComplete from "Components/Patients/SurgeryAutoComplete";
import RepeatOrderPatientAutoComplete from "Components/RepeatOrder/RepeatOrderPatientAutoComplete";

const useStyle = makeStyles((theme) => ({
  rsOrderPadGrid: {
    paddingTop: "0px !important",
    "&>div": {
      // marginBottom: "20px",
      paddingTop: "0px !important",
      [theme.breakpoints.down("900")]: {
        paddingLeft: "25px !important",
        marginBottom: "12px",
      },
      [theme.breakpoints.between("800", "1200")]: {
        paddingTop: "0px !important",
      },
      "&>h3": {
        fontSize: "20px !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
        marginTop: "10px",
      },
    },
  },
  rsPatientCancelBtn: {
    // position: "absolute !important",
    // bottom: "30px",
    position: "relative !important",
    borderRadius: "5px !important",
    height: "37px !important",
    minWidth: "95px !important",
    // textTransform: "uppercase !important",
    fontWeight: "600 !important",
    padding: "8px 13px !important",
    [theme.breakpoints.between("800", "1200")]: {
      position: "relative !important",
      top: "31px",
    },
    [theme.breakpoints.down("800")]: {
      position: "relative !important",
      bottom: "0px",
      margin: "30px 0px !important",
    },
  },
  rsPatientCancelBtnWidth: {
    width: "204px !important",
  },
  rsOrderPadGeneralInfoMain: {
    padding: "17px 13px 5px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    marginBottom: "12px",
    backgroundColor: theme.palette.background.default,
    // marginBottom: "30px",
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "10px",
      fontWeight: "500",
      color: "black",
    },
    "&>div": {
      "&>h4": {
        marginBottom: "20px",
      },
      "&>div": {
        marginBottom: "20px",
      },
    },
    "&>hr": {
      marginBottom: "20px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadGeneralInfo: {
    padding: "17px 13px 25px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    marginBottom: "30px",
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "10px",
      fontWeight: "500",
      color: "black",
    },
    "&>div": {
      "&>h4": {
        marginBottom: "20px",
      },
      "&>div": {
        marginBottom: "20px",
      },
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadPatientSelect: {
    padding: "17px 13px",
    height: "195px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.between("1200", "1449")]: {
      height: "217px",
    },
    [theme.breakpoints.between("800", "1200")]: {
      height: "200px",
      marginBottom: "12px",
    },
    [theme.breakpoints.down("800")]: {
      marginBottom: "12px",
    },
    "&>div": {
      "&>div:nth-child(2)": {
        "&>button": {
          padding: "8px 13px !important",
          // "&>span": {}
        },
      },
    },
    "&>h3": {
      // fontSize: "20px !important",
      // marginBottom: "30px",
      fontSize: "20px !important",
      marginBottom: "10px",
      fontWeight: "500",
      color: "black",
      [theme.breakpoints.down("1560")]: {
        fontSize: "1.188rem !important",
      },
      [theme.breakpoints.down("1503")]: {
        fontSize: "1.125rem !important",
      },
    },
    "&>hr": {
      marginBottom: "20px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadMedicationBtn: {
    padding: "17px 13px 5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: "none !important",
    marginBottom: "30px",
    [theme.breakpoints.down("900")]: {
      marginBottom: "0px !important",
    },
  },
  rsOrderPadProceedBtn: {
    marginRight: "60px !important",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginBottom: "50px !important",
    whiteSpace: "nowrap",
  },
  rsPatientEditBtn: {
    backgroundColor: "#7bbd4b !important",
    whiteSpace: "nowrap",
    height: "35px !important",
    borderRadius: "6px !important",
    // textTransform: "uppercase !important",
    fontWeight: "600 !important",
    "&>span": {
      marginLeft: "-1px",
      marginBottom: "4px",
    },
    "&:disabled": {
      backgroundColor: "grey !important",
      height: "35px !important",
      borderRadius: "6px !important",
    },
    [theme.breakpoints.down("901")]: {
      marginBottom: "10px !important",
      whiteSpace: "nowrap !important",
    },
  },
  tableBody: {
    "&>td": {
      padding: "10px 20px !important",
      borderBottom: `none !important`,
    },
    "& .MuiFormControlLabel-root": {
      // marginLeft: "11px !important",
    },
  },
  labelWhiteSpaceNW: {
    display: "grid !important",
    justifyItems: "center",
    marginLeft: "5px !important",
    marginRight: "5px !important",
    "&>span": {
      whiteSpace: "nowrap",
    },
    "&>div": {
      fontSize: "16px",
      fontWeight: "400 !important",
      "&>svg": {
        width: "25px",
        height: "25px",
      },
    },
  },
  orderDetailTitle: {
    marginBottom: "0px !important",
    "&>h3": {
      color: "black !important",
      fontWeight: "500 !important",
    },
  },
  chipMain: {
    position: "relative",
    // marginLeft: "10px",
    marginTop: "10px",
    // height: "45px !important",
    height: "37px !important",
    // minWidth: "170px !important",
    borderRadius: "5px !important",
    // padding: "4px 15px !important",
    fontSize: "17px !important",
    cursor: "pointer  !important",
    "& .MuiChip-icon": {
      // marginBottom: "5px !important",
      margin: "0px !important",
    },
    "&>svg": {
      width: "20px",
      height: "20px",
    },
    "&>span": {
      marginLeft: "10px  !important",
      padding: "0px  !important",

      "&>div": {
        "&>svg": {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "18px",
          height: "18px",
        },
      },
    },
  },
  chipsgrey: {
    cursor: "default !important",
    borderColor: `rgba(90, 104, 114,0.06) !important`,
    border: "solid !important",
    color: `rgba(90, 104, 114,0.8) !important`,
    background: `rgba(90, 104, 114,0.06) !important`,
    fontSize: "16px !important",
    width: "100px",
    "&>svg": {
      "&>path": {
        fill: `rgba(90, 104, 114,0.8) !important`,
      },
    },
  },
  chips: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    background: `${theme.palette.primary.main}10 !important`,
    fontSize: "16px !important",
    width: "100px",
    "&>svg": {
      "&>path": {
        fill: `${theme.palette.primary.main} !important`,
      },
    },
    "&:hover": {
      background: `${theme.palette.primary.main}20 !important`,
    },
  },
  chipsFilled: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.background.paper} !important`,
    background: `${theme.palette.primary.main} !important`,
    fontSize: "16px !important",
    width: "100px",
    "&>svg": {
      "&>path": {
        fill: ` #ffffff !important`,
      },
    },
    "&:hover": {
      background: `rgb(86, 134, 47) !important`,
    },
  },
  rsGrid: {
    marginBottom: "10px !important",
  },
  rsGridFormControl: {
    display: "flex",
    marginTop: "10px !important",
    marginBottom: "10px !important",
    justifyContent: "space-between",
    alignItems: "end",
    marginLeft: "0px !important",
    [theme.breakpoints.down("1000")]: {
      display: "block",
    },
    "&>label": {
      "&>div": {
        "&>span": {
          fontSize: "16px !important",
          fontWeight: "500 !important",
        },
        "&>svg": {
          width: "20px",
          height: "20px",
        },
      },
    },
  },
  rsFromGroup: {
    marginLeft: "10px !important",
  },
  rsPatientCreateBtn: {
    whiteSpace: "nowrap",
    margin: "10px !important",
  },
  rsBtnSmallScreen: {
    "&>div": {
      "&>button": {
        marginLeft: "0px !important",
      },
    },
  },
  rsTextField: {
    marginBottom: "13px !important",
    width: "85px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: "-12px",
    },
  },
  rsDrugAutoCompleteBox: {
    marginBottom: "13px !important",
    marginRight: "13px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginTop: "3px !important",
    },
  },
  rsErrorHandle: {
    "&>label": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
  },
  managePageH: {
    "&>table": {
      borderTop: "1px solid #e0e0e0 !important",
      borderBottom: "1px solid #e0e0e0 !important",
      borderRight: "1px solid #e0e0e0 !important",
    },
    "& .MuiTableContainer-root": {
      maxHeight: "calc(94vh - 200px) !important",
      padding: "0px !important",
    },
    [theme.breakpoints.down("550")]: {
      "& .MuiTableContainer-root": {
        padding: "0px !important",
      },
    },
  },
  tableContainer: {
    marginBottom: "20px !important",
    height: "auto !important",
    padding: "0 !important ",
    boxShadow: "0px 0px 10px rgba(26, 102, 122, 0.0)!important",
    "&>table": {
      borderTop: "1px solid #e0e0e0 !important",
      borderBottom: "1px solid #e0e0e0 !important",
      borderRight: "1px solid #e0e0e0 !important",
    },
  },
  rsTableBody: {
    borderTop: "1px solid #e0e0e0 !important",
    borderBottom: "1px solid #e0e0e0 !important",
    borderRight: "1px solid #e0e0e0 !important",
    [theme.breakpoints.down("550")]: {
      width: "550px !important",
    },
  },
  orderingmethod: {
    "&>h4": {
      marginTop: "10px",
      fontSize: "18px !important",
      fontWeight: "500 !important",
      color: "black !important",
    },
  },
  MainOrderMethod: {
    paddingTop: "0px !important",
  },
  paddingMain: {
    paddingTop: "0px !important",
    "&:nth-child(2)": {
      paddingLeft: "12px !important",
      [theme.breakpoints.down("800")]: {
        paddingLeft: "0px !important",
      },
      [theme.breakpoints.between("800", "1200")]: {
        paddingLeft: "0px !important",
      },
    },
    marginBottom: "30px !important",
    [theme.breakpoints.down("800")]: {
      marginBottom: "12px !important",
    },
    [theme.breakpoints.between("800", "1200")]: {
      marginBottom: "12px !important",
    },
    "@media (max-height: 770px)": {
      marginBottom: "0px !important",
    },
  },
  rsTitleMedication: {
    position: "sticky",
    top: "0px",
    background: "white",
    zIndex: "10",
    paddingTop: "17px",
    "&>div": {
      "&>button": {
        padding: "8px 13px !important",
        [theme.breakpoints.down("360")]: {
          width: "155px",
        },
      },
      "&>div": {
        "&>button": {
          padding: "8px 13px !important",
        },
        // overflow: "hidden",
        [theme.breakpoints.down("800")]: {
          overflow: "unset",
        },
        "&>div": {
          "&>div": {
            "&>label": {
              fontSize: "9px !important",
            },
            "&>div": {
              "&>div": {
                background: "white",
                zIndex: "2",
              },
            },
          },
          "&>label": {
            zIndex: "1",
          },
        },
      },
      "&>h3": {
        // fontSize: "23px !important",
        fontSize: "19px !important",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("800")]: {
          fontSize: "18px !important",
        },
        fontWeight: "500 !important",
        fontFamily: "Poppins",
        // marginBottom: "10px",
        color: "black !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
        // marginBottom: "20px",
      },
    },
    "&>div:nth-child(1)": {
      padding: "0px 13px",
      [theme.breakpoints.down("800")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.down("360")]: {
        flexDirection: "column",
      },
    },
    "&>div:nth-child(3)": {
      padding: "14px 9px",
      "&>div": {
        marginLeft: "10px",
        "&>label": {
          marginRight: "6px",
          "&>span": {
            padding: "3px",
          },
          "&>span:nth-child(2)": {
            color: "black !important",
          },
        },
        "&>div": {
          "&>label": {
            marginRight: "6px",
            "&>span": {
              padding: "3px",
            },
            "&>span:nth-child(2)": {
              color: "black !important",
              fontWeight: "500",
            },
          },
        },
      },
    },
    // "&>div:nth-child(4)": {
    //   "&>div": {
    //     "&>label": {
    //       // marginRight: "17px",
    //       "&>span": {
    //         padding: "3px",
    //       },
    //     },
    //   },
    // },
  },
  rsPatientPaperGeneralInfoMedi: {
    paddingTop: "0px",
    // paddingRight: "13px",
    // paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>div": {
      "&>div": {
        "&>table": {},
      },
    },
  },
  titleMain: {
    paddingTop: "10px !important",
  },
  rsAddMedicationBtn: {
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)  !important",
      border: "none  !important",
      height: "35px !important",
      padding: "8px 13px !important",
      // textTransform: "uppercase !important",
      [theme.breakpoints.down("800")]: {
        padding: "8px 5px !important",
      },
      "&>span": {
        marginLeft: "0px !important",
        "&>svg": {
          // width: "30px !important",
          // height: "17px !important",
          "&>path": {
            fill: "#5A687290 !important",
          },
        },
      },
    },
    // textTransform: "uppercase !important",
    border: "1px solid #7bbd4b  !important",
    backgroundColor: "#7bbd4b  !important",
    color: "#fff !important",
    padding: "8px 11px !important",
    fontWeight: "600 !important",
    "&>span": {
      marginLeft: "0px !important",
      "&>svg": {
        // width: "30px !important",
        // height: "17px !important",
        "&>path": {
          fill: "#fff !important",
          // stroke: "#fff !important",
        },
      },
    },
    borderRadius: "5px !important",
    height: "35px !important",
  },
  medicineContainer: {
    // width: "45%",
    paddingTop: "0px !important",
    paddingLeft: "12px !important",
    "@media (max-height: 770px)": {
      "&>div:nth-child(1)": {
        maxHeight: "calc(50vh + 100px) !important",
      },
    },
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
      marginBody: "10px",
    },
    "&>div:nth-child(1)": {
      maxHeight: "calc(58vh + 105px)",
      overflow: "auto",
      borderRadius: "10px",
    },
  },
  rsMediValue: {
    paddingLeft: "13px",
    paddingRight: "13px",
  },
  orderCheckboxContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "&>div": {
      "&>div": {
        "&>label": {
          marginLeft: "0px !important",
          marginRight: "10px",
          "&>span": {
            padding: "3px",
          },
        },
      },
    },
  },
  radioButtonContainer: {
    justifyContent: "space-between !important",
    [theme.breakpoints.down("800")]: {
      flexDirection: "column",
    },
  },
  submitContainer: {
    display: "flex",
    justifyContent: "flex-start",

    "&>button": {
      padding: "23px 13px !important",
      minWidth: "120px !important",
    },
  },
  rsPatientEditContainer: {
    // marginTop: "90px",
    marginTop: "15px",
    // [theme.breakpoints.between(900, 1320)]: {
    //   marginTop: "60px !important",
    // },
    // [theme.breakpoints.between(900, 930)]: {
    //   marginTop: "37px !important",
    // },
  },
  generalInfo: {
    display: "flex",
    [theme.breakpoints.down("800")]: {
      flexDirection: "column",
      "&>div": {
        marginRight: "0px !important",
      },
    },
  },
  quantity: {
    marginRight: "20px !important",
    [theme.breakpoints.between("900", "1200")]: {
      marginLeft: "40px !important",
    },
    "&>div": {
      "&>label": {
        fontSize: "9px !important",
      },
    },
  },
  emailTootip: {
    backgroundColor: "#EECA3C !important",
    color: "black !important",
    marginTop: "5px !important",
    fontSize: "16px !important",
    border: "0px solid #dadde9",
    fontWeight: "400 !important",
    width: "100px !important ",
    textAlign: "center !important",
  },
  arrow: {
    "&:before": {
      backgroundColor: "#EECA3C !important",
    },
  },
  disabledEmailTootip: {
    backgroundColor: "#FF5A5A !important",
    width: "170px !important",
    textAlign: "center !important",
    color: "black !important",
    marginTop: "5px !important",
    fontSize: "16px !important",
    border: "0px solid #dadde9",
    fontWeight: "400 !important",
  },
  disabledArrow: {
    "&:before": {
      backgroundColor: "#FF5A5A !important",
    },
  },
  popper: {
    zIndex: "1300 !important",
  },
  rsOrderContainer: {
    minHeight: "calc(83vh - 100px)",
  },
  choosePaitientNameContainer: {
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "space-between !important",
  },
  EmailBox: {
    backgroundColor: "#EECA3C !important",
    color: "black !important",
    marginTop: "10px !important",
    fontSize: "16px !important",
    border: "0px solid #dadde9",
    fontWeight: "400 !important",
    width: "100px !important ",
    textAlign: "center !important",
    // marginBottom: "17px",
    justifyContent: "center",
    borderRadius: "5px",
    whiteSpace: "nowrap",
    padding: "9px 10px",
    height: "40px",
    "&>span": {
      height: "15px",
      width: "15px",
      position: "relative",
      left: "33px",
      transform: "rotate(45deg)",
      display: "flex",
      top: "-2px",
      backgroundColor: "#EECA3C !important",
    },
    "&>span:before": {
      bottom: "0",
      marginBottom: "-0.71em",
      transform: "translate(42px, 0px)",
      transformOrigin: "100% 0",
      content: "",
      margin: "auto",
      display: "block",
      width: "100%",
      height: "100%",
      transform: "rotate(45deg)",
      backgroundColor: "#EECA3C !important",
    },
  },
  EmailBoxnot: {
    backgroundColor: "#FF5A5A !important",
    color: "black !important",
    marginTop: "10px !important",
    fontSize: "14px !important",
    border: "0px solid #dadde9",
    fontWeight: "400 !important",
    width: "100px !important ",
    textAlign: "center !important",
    // marginBottom: "17px",
    justifyContent: "center",
    borderRadius: "5px",
    // whiteSpace: "nowrap",
    padding: "8px 6px",
    height: "58px",
    "&>span": {
      height: "15px",
      width: "15px",
      position: "relative",
      left: "39px",
      transform: "rotate(45deg)",
      display: "flex",
      top: "-2px",
      backgroundColor: "#FF5A5A !important",
    },
    "&>span:before": {
      bottom: "0",
      marginBottom: "-0.71em",
      transform: "translate(42px, 0px)",
      transformOrigin: "100% 0",
      content: "",
      margin: "auto",
      display: "block",
      width: "100%",
      height: "100%",
      transform: "rotate(45deg)",
      backgroundColor: "#EECA3C !important",
    },
  },
}));
const OrderToNewRx = (props) => {
  const classes = useStyle();
  const {
    searchRepeatOrder,
    handleSubmit,
    selectedPatientInfo,
    query,
    setSelectedPatientInfo,
    setFieldValue,
    setFieldTouched,
    handlePatientDetailsChange,
    currentPageType,
    touched,
    errors,
    values,
    handleChange,
    orderType,
    showMedication,
    setShowMedication,
    setShowNoOfMedication,
    showNoOfMedication,
    checkAllAction,
    setCheckAllAction,
    medications,
    setMedications,
    handleChangeAction,
    medicationActionCheck,
    handleBlur,
    setCreateDrug,
    showWholeForm,
    createOrderPadData,
    showCreateNewRx,
    handleDialog,
    setIsOpenNewPatientPopup,
    OrderingMethod,
    defaultOrderingMethod,
    orderActionType,
    setOrderActionTypeActionType,
    listOpen,
    setListOpen,
    medicationRef,
    handleClickAddDrug,
    handleDrugChange,
    handleChangeQuantity,
    blankMediation,
    quantityRef,
  } = props;
  const { width } = useViewport();
  const loginUserDetail = useSelector((state) => state.user);
  const showDataBasedOnRole =
    loginUserDetail?.loginUserDetail?.data?.data?.role;
  const handlePatientDailog = () => {
    setIsOpenNewPatientPopup(true);
  };
  return (
    <>
      {orderType === "createNewOrder" && (
        <Grid>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
              if (values.surgery_id === undefined || values.surgery_id === null || values.surgery_id === "") {
                setFieldTouched("surgery_id", true, false);
              }
              setTimeout(() => {
                const errorId = ["name", "quantity"];
                let foundError = false;
                for (let i = 0; i <= medications.length; i++) {
                  if (foundError) {
                    break;
                  }
                  for (let j = 0; j <= errorId.length; j++) {
                    const element = document.getElementById(
                      `${errorId[j]}_${i}`,
                    );
                    if (
                      element?.parentElement?.nextSibling?.classList?.contains(
                        "Mui-error",
                      )
                    ) {
                      element.focus();
                      foundError = true;
                      break;
                    }
                  }
                }
              }, 1000);
            }}
          >
            <Grid
              container
              columnSpacing={2.5}
              rowSpacing={3}
              className={clsx(classes.rsOrderContainer, classes.rsOrderPadGrid)}
            >
              {width >= 1200 ? (
                <>
                  {orderType === "createNewOrder" && showCreateNewRx && (
                    <Grid
                      item
                      sm={12}
                      xs={12}
                      xl={2.5}
                      lg={2.5}
                      md={2.5}
                      className={clsx(
                        classes.paddingMain,
                        classes.choosePaitientNameContainer,
                      )}
                    >
                      <Paper
                        elevation={1}
                        className={classes.rsOrderPadPatientSelect}
                      >
                        <Typography variant="h3" medium color="secondary">
                          Choose Patient Name
                        </Typography>
                        <Divider />
                        <Grid
                          display={"flex"}
                          flexDirection={"column"}
                          justifyContent={"space-between"}
                          height={"-webkit-fill-available"}
                        >
                          <Box display={"flex"} alignItems={"center"}>
                            <RepeatOrderPatientAutoComplete
                              fullWidth
                              value={selectedPatientInfo}
                              disabled={
                                query.get("actionType") === "repeatOrderPage"
                              }
                              className={classes.autoCompleteBox}
                              onChange={(e, value) => {
                                if (value === null) {
                                  setFieldValue("patient_id", "");
                                  setSelectedPatientInfo({});
                                  handlePatientDetailsChange(null);
                                  return;
                                }
                                setSelectedPatientInfo(value);
                                setFieldValue("patient_id", value?.id);
                                handlePatientDetailsChange(value);
                              }}
                              buttonOptionTop={true}
                              buttonTitle={"Create New Patient"}
                              handleButtonClick={handlePatientDailog}
                              currentPageType={currentPageType}
                              orderType={orderType}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  autoFocus
                                  label="Choose Patient Name *"
                                  error={
                                    touched?.patient_id && errors?.patient_id
                                  }
                                  helperText={
                                    touched?.patient_id && errors?.patient_id
                                  }
                                />
                              )}
                            />
                            {/* {width > 1540 && showDataBasedOnRole !== "user" && (
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Button
                            className={classes.rsPatientCreateBtn}
                            children=" Create New Patient"
                            variant="outlined"
                            color="primary"
                            disabled={values?.patient_id}
                            startIcon={
                              <PrimaryIcon
                                icon={AddIcon}
                                color="primary"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setIsOpenNewPatientPopup(true);
                            }}
                          />
                        </Grid>
                      )} */}
                          </Box>
                          {/* {width < 1540 && showDataBasedOnRole !== "user" && (
                      <Box className={classes.rsBtnSmallScreen}>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Button
                            className={classes.rsPatientCreateBtn}
                            children=" Create New Patient"
                            variant="outlined"
                            color="primary"
                            disabled={values?.patient_id}
                            startIcon={
                              <PrimaryIcon
                                icon={AddIcon}
                                color="primary"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setIsOpenNewPatientPopup(true);
                            }}
                          />
                        </Grid>
                      </Box>
                    )} */}

                          <Box className={classes.rsPatientEditContainer}>
                            {showDataBasedOnRole !== "user" && (
                              <Button
                                className={classes.rsPatientEditBtn}
                                children="Edit Patient"
                                variant="contained"
                                color="primary"
                                disabled={
                                  values.patient_id === ""
                                  // ||
                                  // showNoOfMedication ||
                                  // medicationActionCheck.length === 0
                                }
                                startIcon={
                                  <PrimaryIcon
                                    icon={EditIconTwo}
                                    color="white"
                                    width="16px"
                                    height="16px"
                                  />
                                }
                                onClick={() => {
                                  setCreateDrug(true);
                                }}
                              />
                            )}
                          </Box>
                        </Grid>
                      </Paper>
                      {showWholeForm &&
                        width >= 1200 &&
                        !searchRepeatOrder?.loading && (
                          <>
                            <Grid className={classes.submitContainer}>
                              <Button
                                children={
                                  values?.ordering_method === "email"
                                    ? "Proceed & Send Email"
                                    : "Proceed"
                                }
                                variant="contained"
                                type="submit"
                                color="primary"
                                disabled={createOrderPadData?.loading}
                                startIcon={
                                  createOrderPadData?.loading && (
                                    <CircularProgress
                                      color="white"
                                      size="20px"
                                    />
                                  )
                                }
                                className={
                                  values?.ordering_method !== "email"
                                    ? clsx(
                                      "BtnGreen",
                                      classes.rsPatientCancelBtn,
                                    )
                                    : clsx(
                                      "BtnGreen",
                                      classes.rsPatientCancelBtn,
                                      classes.rsPatientCancelBtnWidth,
                                    )
                                }
                              />
                            </Grid>
                          </>
                        )}
                    </Grid>
                  )}
                  {searchRepeatOrder?.loading && (
                    <Grid
                      item
                      xl={9.5}
                      lg={9.5}
                      md={9.5}
                      sm={12}
                      xs={12}
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      style={{ minHeight: "350px" }}
                    >
                      <CircularProgress />
                      <Typography
                        variant="h4"
                        style={{
                          marginTop: "20px",
                          color: "#747474",
                          fontWeight: 400,
                        }}
                      >
                        Loading patient details...
                      </Typography>
                    </Grid>
                  )}
                  {showWholeForm && !searchRepeatOrder?.loading && (
                    <>
                      <Grid
                        item
                        sm={12}
                        xs={12}
                        xl={4}
                        lg={4}
                        md={4}
                        className={classes.paddingMain}
                      >
                        <Paper
                          elevation={1}
                          className={classes.rsOrderPadGeneralInfoMain}
                        >
                          <Typography variant="h3" medium color="secondary">
                            General Information
                          </Typography>
                          <Divider />
                          <Box className={classes.generalInfo}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              marginRight={"20px"}
                            >
                              <TextField
                                disabled
                                className={classes.marginTop}
                                variant="outlined"
                                fullWidth
                                placeholder="Name *"
                                label="Name *"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                name="name"
                                value={values?.name}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  disabled
                                  className={classes.rsErrorHandle}
                                  disableFuture
                                  label="Date of birth "
                                  views={["year", "month", "day"]}
                                  inputFormat="DD-MM-YYYY"
                                  value={values?.dob ? values?.dob : "" || null}
                                  onChange={(newDate) => {
                                    setFieldValue("dob", newDate);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      className={classes.marginTop}
                                      fullWidth
                                      size="small"
                                      name="dob"
                                      {...params}
                                    />
                                  )}
                                  name="dob"
                                />
                              </LocalizationProvider>
                            </Grid>
                          </Box>
                          <Box className={classes.generalInfo}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              marginRight={"20px"}
                            >
                              <SurgeryAutoComplete
                                disabled={selectedPatientInfo?.surgery_name?.id}
                                fullWidth
                                className={classes.autoCompleteBox}
                                value={values?.surgery_info}
                                onChange={(e, value) => {
                                  setFieldValue("ordering_method", value?.ordering_method);
                                  setFieldValue("surgery_info", value);
                                  setFieldValue("surgery_id", value.id);
                                  setFieldTouched("surgery_id", true, false);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    className={classes.marginTop}
                                    {...params}
                                    label="Surgery *"
                                    error={
                                      touched?.surgery_id &&
                                      Boolean(errors?.surgery_id)
                                    }
                                    helperText={
                                      touched?.surgery_id &&
                                      errors?.surgery_id
                                    }
                                  />
                                )}
                              />
                            </Grid>
                            {showDataBasedOnRole === "admin" && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={6}
                                className={classes.rsGrid}
                              >
                                <PharmacyAutoComplete
                                  disabled
                                  fullWidth
                                  className={classes.autoCompleteBox}
                                  value={values?.pharmacy_info}
                                  onChange={(e, value) => {
                                    setFieldValue("pharmacy_info", value);
                                    setFieldValue("pharmacy_id", value.id);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      className={classes.marginTop}
                                      {...params}
                                      label="Pharmacy *"
                                    />
                                  )}
                                />
                              </Grid>
                            )}
                          </Box>
                        </Paper>

                        <Grid className={classes.MainOrderMethod}>
                          <Paper
                            elevation={1}
                            className={classes.rsOrderPadMedicationBtn}
                          >
                            <Grid
                              container
                              columnSpacing={2.5}
                              // rowSpacing={3}
                              className={classes.rsOrderPadGrid}
                            >
                              <Grid
                                item
                                xs={12}
                                className={classes.orderDetailTitle}
                              >
                                <Typography
                                  variant="h3"
                                  medium
                                  color="secondary"
                                >
                                  Order Details
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Divider />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Grid
                                  // display={"contents"}
                                  className={classes.orderingmethod}
                                >
                                  <Typography
                                    medium
                                    variant="h4"
                                    color={"black"}
                                  >
                                    Best Ordering Method *
                                  </Typography>
                                  <Grid
                                    className={classes.rsGridFormControl}
                                    // rowSpacing={1}
                                    container
                                  // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                  >
                                    <>
                                      {OrderingMethod?.map((item, index) => {
                                        return (
                                          <FormControlLabel
                                            item
                                            error={
                                              touched?.ordering_method &&
                                              errors?.ordering_method
                                            }
                                            helperText={
                                              touched?.ordering_method &&
                                              errors?.ordering_method
                                            }
                                            onBlur={handleBlur}
                                            className={
                                              classes.labelWhiteSpaceNW
                                            }
                                            value={item}
                                            key={index}
                                            onClick={() => {
                                              // setFieldValue(
                                              //   "ordering_method",
                                              //   item?.type || ""
                                              // );
                                              // handleChange(
                                              //   "ordering_method",
                                              //   item?.type || ""
                                              // );
                                              // handleDialog(
                                              //   medications,
                                              //   values?.number_of_medication,
                                              //   item?.type
                                              // );
                                              if (values?.surgery_info?.email) {
                                                setFieldValue(
                                                  "ordering_method",
                                                  item?.type || "",
                                                );
                                                handleChange(
                                                  "ordering_method",
                                                  item?.type || "",
                                                );
                                                handleDialog(
                                                  medications,
                                                  values?.number_of_medication,
                                                  item?.type,
                                                );
                                              } else {
                                                if (item?.type == "email") {
                                                } else {
                                                  setFieldValue(
                                                    "ordering_method",
                                                    item?.type || "",
                                                  );
                                                  handleChange(
                                                    "ordering_method",
                                                    item?.type || "",
                                                  );
                                                  handleDialog(
                                                    medications,
                                                    values?.number_of_medication,
                                                    item?.type,
                                                  );
                                                }
                                              }
                                            }}
                                            control={
                                              values?.surgery_info?.email ? (
                                                <>
                                                  {values?.ordering_method ==
                                                    item.type && (
                                                      <Box
                                                        className={
                                                          classes.EmailBox
                                                        }
                                                      >
                                                        Preferred
                                                        <span></span>
                                                      </Box>
                                                    )}
                                                  <Chip
                                                    icon={item?.icon}
                                                    checked={
                                                      values?.ordering_method ==
                                                      item.type
                                                    }
                                                    className={clsx(
                                                      classes.chipMain,
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? classes.chipsFilled
                                                        : classes.chips,
                                                    )}
                                                    label={
                                                      <div>{item?.item}</div>
                                                    }
                                                    color={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "primary"
                                                        : "default"
                                                    }
                                                    variant={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "filled"
                                                        : "outlined"
                                                    }
                                                  />
                                                </>
                                              ) : item?.type == "email" ? (
                                                <>
                                                  {item?.item && (
                                                    <Box
                                                      className={
                                                        classes.EmailBoxnot
                                                      }
                                                    >
                                                      No email available{" "}
                                                      <span></span>
                                                    </Box>
                                                  )}

                                                  <Chip
                                                    icon={item?.icon}
                                                    // checked={
                                                    //   values?.ordering_method ==
                                                    //   item.type
                                                    // }
                                                    className={clsx(
                                                      classes.chipMain,
                                                      classes.chipsgrey,
                                                    )}
                                                    label={
                                                      <div>{item?.item}</div>
                                                    }
                                                    color={"default"}
                                                    variant={"outlined"}
                                                  />
                                                </>
                                              ) : (
                                                <>
                                                  {values?.ordering_method ==
                                                    item.type && (
                                                      <Box
                                                        className={
                                                          classes.EmailBox
                                                        }
                                                      >
                                                        Preferred
                                                        <span></span>
                                                      </Box>
                                                    )}
                                                  <Chip
                                                    icon={item?.icon}
                                                    checked={
                                                      values?.ordering_method ==
                                                      item.type
                                                    }
                                                    className={clsx(
                                                      classes.chipMain,
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? classes.chipsFilled
                                                        : classes.chips,
                                                    )}
                                                    label={
                                                      <div>{item?.item}</div>
                                                    }
                                                    color={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "primary"
                                                        : "default"
                                                    }
                                                    variant={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "filled"
                                                        : "outlined"
                                                    }
                                                  />
                                                </>
                                              )
                                            }
                                          />
                                        );
                                      })}
                                    </>
                                  </Grid>
                                  <FormHelperText
                                    error={
                                      touched?.ordering_method &&
                                      errors?.ordering_method
                                    }
                                    style={{
                                      marginTop: "-10px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    {touched?.ordering_method &&
                                      errors?.ordering_method}
                                  </FormHelperText>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </>
              ) : (
                <Grid item sm={12} xs={12} xl={6} lg={6} md={6}>
                  {orderType === "createNewOrder" && showCreateNewRx && (
                    <Grid
                      item
                      sm={12}
                      xs={12}
                      xl={2.5}
                      lg={2.5}
                      md={12}
                      className={classes.paddingMain}
                    >
                      <Paper
                        elevation={1}
                        className={classes.rsOrderPadPatientSelect}
                      >
                        <Typography variant="h3" medium color="secondary">
                          Choose Patient Name
                        </Typography>
                        <Divider />
                        <Grid
                          display={"flex"}
                          flexDirection={"column"}
                          justifyContent={"space-between"}
                          height={"-webkit-fill-available"}
                        >
                          <Box display={"flex"} alignItems={"center"}>
                            <RepeatOrderPatientAutoComplete
                              fullWidth
                              value={selectedPatientInfo}
                              disabled={
                                query.get("actionType") === "repeatOrderPage"
                              }
                              className={classes.autoCompleteBox}
                              onChange={(e, value) => {
                                if (value === null) {
                                  setFieldValue("patient_id", "");
                                  setSelectedPatientInfo({});
                                  handlePatientDetailsChange(null);
                                  return;
                                }
                                setSelectedPatientInfo(value);
                                setFieldValue("patient_id", value?.id);
                                handlePatientDetailsChange(value);
                              }}
                              buttonOptionTop={true}
                              buttonTitle={"Create New Patient"}
                              handleButtonClick={handlePatientDailog}
                              currentPageType={currentPageType}
                              orderType={orderType}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  autoFocus
                                  label="Choose Patient Name *"
                                  error={
                                    touched?.patient_id && errors?.patient_id
                                  }
                                  helperText={
                                    touched?.patient_id && errors?.patient_id
                                  }
                                />
                              )}
                            />
                            {/* {width > 1540 && showDataBasedOnRole !== "user" && (
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Button
                            className={classes.rsPatientCreateBtn}
                            children=" Create New Patient"
                            variant="outlined"
                            color="primary"
                            disabled={values?.patient_id}
                            startIcon={
                              <PrimaryIcon
                                icon={AddIcon}
                                color="primary"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setIsOpenNewPatientPopup(true);
                            }}
                          />
                        </Grid>
                      )} */}
                          </Box>
                          {/* {width < 1540 && showDataBasedOnRole !== "user" && (
                      <Box className={classes.rsBtnSmallScreen}>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Button
                            className={classes.rsPatientCreateBtn}
                            children=" Create New Patient"
                            variant="outlined"
                            color="primary"
                            disabled={values?.patient_id}
                            startIcon={
                              <PrimaryIcon
                                icon={AddIcon}
                                color="primary"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setIsOpenNewPatientPopup(true);
                            }}
                          />
                        </Grid>
                      </Box>
                    )} */}

                          <Box className={classes.rsPatientEditContainer}>
                            {showDataBasedOnRole !== "user" && (
                              <Button
                                className={classes.rsPatientEditBtn}
                                children="Edit Patient"
                                variant="contained"
                                color="primary"
                                disabled={
                                  values.patient_id === "" ||
                                  showNoOfMedication ||
                                  medicationActionCheck.length === 0
                                }
                                startIcon={
                                  <PrimaryIcon
                                    icon={EditIconTwo}
                                    color="white"
                                    width="16px"
                                    height="16px"
                                  />
                                }
                                onClick={() => {
                                  setCreateDrug(true);
                                }}
                              />
                            )}
                          </Box>
                        </Grid>
                      </Paper>
                    </Grid>
                  )}
                  {searchRepeatOrder?.loading && (
                    <Grid
                      item
                      sm={12}
                      xs={12}
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      style={{ minHeight: "350px" }}
                    >
                      <CircularProgress size={50} thickness={4} />
                      <Typography
                        variant="h4"
                        style={{
                          marginTop: "20px",
                          color: "#747474",
                          fontWeight: 500,
                        }}
                      >
                        Loading patient details...
                      </Typography>
                    </Grid>
                  )}

                  {showWholeForm && !searchRepeatOrder?.loading && (
                    <>
                      <Grid
                        sm={12}
                        xs={12}
                        xl={4}
                        lg={4}
                        md={12}
                        className={classes.paddingMain}
                      >
                        <Paper
                          elevation={1}
                          className={classes.rsOrderPadGeneralInfoMain}
                        >
                          <Typography variant="h3" medium color="secondary">
                            General Information
                          </Typography>
                          <Divider />
                          <Box className={classes.generalInfo}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              marginRight={"20px"}
                            >
                              <TextField
                                disabled
                                className={classes.marginTop}
                                variant="outlined"
                                fullWidth
                                placeholder="Name *"
                                label="Name *"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                name="name"
                                value={values?.name}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  disabled
                                  className={classes.rsErrorHandle}
                                  disableFuture
                                  label="Date of birth "
                                  views={["year", "month", "day"]}
                                  inputFormat="DD-MM-YYYY"
                                  value={values?.dob ? values?.dob : "" || null}
                                  onChange={(newDate) => {
                                    setFieldValue("dob", newDate);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      className={classes.marginTop}
                                      fullWidth
                                      size="small"
                                      name="dob"
                                      {...params}
                                    />
                                  )}
                                  name="dob"
                                />
                              </LocalizationProvider>
                            </Grid>
                          </Box>
                          <Box className={classes.generalInfo}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              marginRight={"20px"}
                            >
                              <SurgeryAutoComplete
                                disabled
                                fullWidth
                                className={classes.autoCompleteBox}
                                value={values?.surgery_info}
                                onChange={(e, value) => {
                                  setFieldValue("surgery_info", value);
                                  setFieldValue("surgery_id", value.id);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    className={classes.marginTop}
                                    {...params}
                                    label="Surgery *"
                                  />
                                )}
                              />
                            </Grid>
                            {showDataBasedOnRole === "admin" && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={6}
                                className={classes.rsGrid}
                              >
                                <PharmacyAutoComplete
                                  disabled
                                  fullWidth
                                  className={classes.autoCompleteBox}
                                  value={values?.pharmacy_info}
                                  onChange={(e, value) => {
                                    setFieldValue("pharmacy_info", value);
                                    setFieldValue("pharmacy_id", value.id);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      className={classes.marginTop}
                                      {...params}
                                      label="Pharmacy *"
                                    />
                                  )}
                                />
                              </Grid>
                            )}
                          </Box>
                        </Paper>

                        <Grid className={classes.MainOrderMethod}>
                          <Paper
                            elevation={1}
                            className={classes.rsOrderPadMedicationBtn}
                          >
                            <Grid
                              container
                              columnSpacing={2.5}
                              // rowSpacing={3}
                              className={classes.rsOrderPadGrid}
                            >
                              <Grid
                                item
                                xs={12}
                                className={classes.orderDetailTitle}
                              >
                                <Typography
                                  variant="h3"
                                  medium
                                  color="secondary"
                                >
                                  Order Details
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Divider />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Grid
                                  // display={"contents"}
                                  className={classes.orderingmethod}
                                >
                                  <Typography
                                    medium
                                    variant="h4"
                                    color={"black"}
                                  >
                                    Best Ordering Method *
                                  </Typography>
                                  <Grid
                                    className={classes.rsGridFormControl}
                                    container
                                  // marginTop={"117px !important"}
                                  >
                                    <>
                                      {OrderingMethod?.map((item, index) => {
                                        return (
                                          <FormControlLabel
                                            item
                                            error={
                                              touched?.ordering_method &&
                                              errors?.ordering_method
                                            }
                                            helperText={
                                              touched?.ordering_method &&
                                              errors?.ordering_method
                                            }
                                            onBlur={handleBlur}
                                            className={
                                              classes.labelWhiteSpaceNW
                                            }
                                            value={item}
                                            key={index}
                                            onClick={() => {
                                              // setFieldValue(
                                              //   "ordering_method",
                                              //   item?.type || ""
                                              // );
                                              // handleChange(
                                              //   "ordering_method",
                                              //   item?.type || ""
                                              // );
                                              // handleDialog(
                                              //   medications,
                                              //   values?.number_of_medication,
                                              //   item?.type
                                              // );
                                              if (values?.surgery_info?.email) {
                                                setFieldValue(
                                                  "ordering_method",
                                                  item?.type || "",
                                                );
                                                handleChange(
                                                  "ordering_method",
                                                  item?.type || "",
                                                );
                                                handleDialog(
                                                  medications,
                                                  values?.number_of_medication,
                                                  item?.type,
                                                );
                                              } else {
                                                if (item?.type == "email") {
                                                } else {
                                                  setFieldValue(
                                                    "ordering_method",
                                                    item?.type || "",
                                                  );
                                                  handleChange(
                                                    "ordering_method",
                                                    item?.type || "",
                                                  );
                                                  handleDialog(
                                                    medications,
                                                    values?.number_of_medication,
                                                    item?.type,
                                                  );
                                                }
                                              }
                                            }}
                                            control={
                                              values?.surgery_info?.email ? (
                                                <>
                                                  {values?.ordering_method ==
                                                    item.type && (
                                                      <Box
                                                        className={
                                                          classes.EmailBox
                                                        }
                                                      >
                                                        Preferred
                                                        <span></span>
                                                      </Box>
                                                    )}
                                                  <Chip
                                                    icon={item?.icon}
                                                    checked={
                                                      values?.ordering_method ==
                                                      item.type
                                                    }
                                                    className={clsx(
                                                      classes.chipMain,
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? classes.chipsFilled
                                                        : classes.chips,
                                                    )}
                                                    label={
                                                      <div>{item?.item}</div>
                                                    }
                                                    color={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "primary"
                                                        : "default"
                                                    }
                                                    variant={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "filled"
                                                        : "outlined"
                                                    }
                                                  />
                                                </>
                                              ) : item?.type == "email" ? (
                                                <>
                                                  {item?.item && (
                                                    <Box
                                                      className={
                                                        classes.EmailBoxnot
                                                      }
                                                    >
                                                      No email available{" "}
                                                      <span></span>
                                                    </Box>
                                                  )}

                                                  <Chip
                                                    icon={item?.icon}
                                                    // checked={
                                                    //   values?.ordering_method ==
                                                    //   item.type
                                                    // }
                                                    className={clsx(
                                                      classes.chipMain,
                                                      classes.chipsgrey,
                                                    )}
                                                    label={
                                                      <div>{item?.item}</div>
                                                    }
                                                    color={"default"}
                                                    variant={"outlined"}
                                                  />
                                                </>
                                              ) : (
                                                <>
                                                  {values?.ordering_method ==
                                                    item.type && (
                                                      <Box
                                                        className={
                                                          classes.EmailBox
                                                        }
                                                      >
                                                        Preferred
                                                        <span></span>
                                                      </Box>
                                                    )}
                                                  <Chip
                                                    icon={item?.icon}
                                                    checked={
                                                      values?.ordering_method ==
                                                      item.type
                                                    }
                                                    className={clsx(
                                                      classes.chipMain,
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? classes.chipsFilled
                                                        : classes.chips,
                                                    )}
                                                    label={
                                                      <div>{item?.item}</div>
                                                    }
                                                    color={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "primary"
                                                        : "default"
                                                    }
                                                    variant={
                                                      values?.ordering_method ==
                                                        item.type
                                                        ? "filled"
                                                        : "outlined"
                                                    }
                                                  />
                                                </>
                                              )
                                            }
                                          />
                                        );
                                      })}
                                    </>
                                  </Grid>
                                  <FormHelperText
                                    error={
                                      touched?.ordering_method &&
                                      errors?.ordering_method
                                    }
                                    style={{
                                      marginTop: "-10px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    {touched?.ordering_method &&
                                      errors?.ordering_method}
                                  </FormHelperText>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              )}

              {showWholeForm && !searchRepeatOrder?.loading && (
                <>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    xl={5.5}
                    lg={5.5}
                    md={width < 1200 ? 6 : 5.5}
                    className={classes.medicineContainer}
                  >
                    <Paper
                      elevation={1}
                      className={classes.rsPatientPaperGeneralInfoMedi}
                    // className={classes.rsOrderPadGeneralInfoTable}
                    >
                      <Grid container className={classes.rsPatientGridOne}>
                        <Grid
                          item
                          xs={12}
                          className={classes.rsTitleMedication}
                        >
                          <Grid
                            position={"sticky"}
                            display={"flex"}
                            justifyContent={"space-between"}
                            width={"-webkit-fill-available"}
                            xs={12}
                          >
                            <Typography variant="h3" medium color="secondary">
                              Medicine details
                            </Typography>
                            <Button
                              className={clsx(
                                "BtnGreen",
                                classes.rsAddMedicationBtn,
                              )}
                              children="Add Medicine"
                              color="primary"
                              variant="contained"
                              disabled={
                                showNoOfMedication || blankMediation.length > 0
                              }
                              startIcon={
                                <PrimaryIcon
                                  icon={AddIcon}
                                  color="white"
                                  width="16px"
                                  height="16px"
                                />
                              }
                              onClick={() => {
                                setOrderActionTypeActionType("orderCreate");
                                handleClickAddDrug();
                                setListOpen(true);
                                medicationRef?.current?.focus();
                              }}
                            />
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            paddingLeft={"13px"}
                            paddingRight={"13px"}
                            paddingTop={"10px"}
                          >
                            <Divider />
                          </Grid>

                          <Box
                            display={"flex"}
                            padding={"0px 17px"}
                            className={
                              showMedication && classes.radioButtonContainer
                            }
                          >
                            {/* {width < 768 ? (
                              <Grid item xs={12} sm={12} md={12}>
                                <FormGroup>
                                  <FormControlLabel
                                    className={classes.rsSurgryFormControl}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={showMedication}
                                        onChange={() => {
                                          setShowMedication(!showMedication);
                                          setShowNoOfMedication(false);
                                          setListOpen(false);
                                        }}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                      />
                                    }
                                    label="Select specific medications"
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <FormControlLabel
                                    className={classes.rsSurgryFormControl}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={showNoOfMedication}
                                        onChange={() => {
                                          setShowNoOfMedication(
                                            !showNoOfMedication
                                          );
                                          setShowMedication(false);
                                        }}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                      />
                                    }
                                    label="Unspecific prescription to collect"
                                  />
                                </FormGroup>
                              </Grid>
                            ) : (
                              <>
                                <FormGroup>
                                  <FormControlLabel
                                    className={classes.rsSurgryFormControl}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={showMedication}
                                        onChange={() => {
                                          setShowMedication(!showMedication);
                                          setShowNoOfMedication(false);
                                          setListOpen(false);
                                        }}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                      />
                                    }
                                    label="Select specific medications"
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <FormControlLabel
                                    className={classes.rsSurgryFormControl}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={showNoOfMedication}
                                        onChange={() => {
                                          setShowNoOfMedication(
                                            !showNoOfMedication
                                          );
                                          setShowMedication(false);
                                        }}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                      />
                                    }
                                    label="Unspecific prescription to collect"
                                  />
                                </FormGroup>
                              </>
                            )} */}
                            {showMedication && (
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"flex-start"}
                                marginLeft={"10px"}
                              >
                                <FormGroup>
                                  <FormControlLabel
                                    label={"Order All"}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={checkAllAction}
                                        className={classes.orderCheckBox}
                                        onChange={(e, value) => {
                                          const isChecked = !checkAllAction;
                                          setCheckAllAction(isChecked);

                                          const _medications = medications?.map(
                                            (item) => {
                                              item.action = isChecked;
                                              return item;
                                            },
                                          );
                                          setMedications(_medications);
                                        }}
                                      />
                                    }
                                  />
                                </FormGroup>
                              </Box>
                            )}
                          </Box>
                        </Grid>
                        {showMedication && (
                          <>
                            <Grid item xs={12} className={classes.rsMediValue}>
                              {medications?.map((item, index) => {
                                return (
                                  <>
                                    <Grid className={classes.tableBody}>
                                      <Grid
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                      >
                                        <Grid
                                          className={
                                            classes.orderCheckboxContainer
                                          }
                                        >
                                          <Grid>
                                            <FormGroup>
                                              <FormControlLabel
                                                // label={"Order"}
                                                control={
                                                  <Checkbox
                                                    color="primary"
                                                    checked={
                                                      item?.action
                                                        ? item?.action
                                                        : false
                                                    }
                                                    onChange={(e, value) => {
                                                      handleChangeAction(
                                                        e,
                                                        index,
                                                      );
                                                    }}
                                                  />
                                                }
                                              />
                                            </FormGroup>
                                          </Grid>
                                        </Grid>
                                        <DrugAutoComplete
                                          listOpen={listOpen}
                                          fullWidth
                                          disabled={!item.isNew}
                                          filterMedication={medications}
                                          className={
                                            classes.rsDrugAutoCompleteBox
                                          }
                                          value={item}
                                          onChange={(e, value) => {
                                            value = value
                                              ? {
                                                ...value,
                                                name: value?.label,
                                              }
                                              : value;
                                            delete value?.label;
                                            handleDrugChange(e, index, value);
                                            handleChange("drug", value);
                                            quantityRef.current.focus();
                                          }}
                                          id={`name_${index}`}
                                          orderActionType={orderActionType}
                                          onBlur={handleBlur}
                                          renderInput={(params) => (
                                            <>
                                              <TextField
                                                {...params}
                                                inputRef={
                                                  orderActionType ===
                                                    "orderCreate"
                                                    ? medicationRef
                                                    : ""
                                                }
                                                id={`name_${index}`}
                                                autoFocus={
                                                  orderActionType ===
                                                  "orderCreate"
                                                }
                                                label="Drug Name"
                                                placeholder="Choose Drug"
                                                error={
                                                  item?.errors?.name &&
                                                  item?.errors?.name
                                                }
                                                helperText={
                                                  item?.errors?.name &&
                                                  item?.errors?.name
                                                }
                                                onBlur={handleBlur}
                                              />
                                            </>
                                          )}
                                        />

                                        {(width > 1200 || width < 900) && (
                                          <Grid
                                            xs={3}
                                            sm={1.8}
                                            md={2.2}
                                            lg={1.9}
                                            xl={1.3}
                                            className={classes.quantity}
                                          >
                                            <TextField
                                              variant="outlined"
                                              fullWidth
                                              inputRef={quantityRef}
                                              disabled={!item.isNew}
                                              inputProps={{ maxLength: 10 }}
                                              placeholder="Quantity"
                                              label="Quantity"
                                              size="small"
                                              value={item.quantity}
                                              id={`quantity_${index}`}
                                              name={`medications[${index}]`}
                                              onChange={(e, value) => {
                                                handleChangeQuantity(e, index);
                                                handleChange(e);
                                              }}
                                              error={
                                                item?.errors?.quantity &&
                                                item?.errors?.quantity
                                              }
                                              helperText={
                                                item?.errors?.quantity &&
                                                item?.errors?.quantity
                                              }
                                              onBlur={handleBlur}
                                              className={classes.rsTextField}
                                            />
                                          </Grid>
                                        )}
                                      </Grid>
                                      {/* <Grid
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        display={"flex"}
                                        justifyContent={"flex-start"}
                                        alignItems={"center"}
                                      >
                                       
                                      </Grid> */}
                                    </Grid>

                                    {width <= 1200 && width >= 900 && (
                                      <Grid
                                        xs={3}
                                        sm={1.8}
                                        md={2.2}
                                        lg={1.9}
                                        xl={1.3}
                                        className={classes.quantity}
                                      >
                                        <TextField
                                          variant="outlined"
                                          fullWidth
                                          inputRef={quantityRef}
                                          disabled={!item.isNew}
                                          inputProps={{ maxLength: 10 }}
                                          placeholder="Quantity"
                                          label="Quantity"
                                          size="small"
                                          value={item.quantity}
                                          id={`quantity_${index}`}
                                          name={`medications[${index}]`}
                                          onChange={(e, value) => {
                                            handleChangeQuantity(e, index);
                                            handleChange(e);
                                          }}
                                          error={
                                            item?.errors?.quantity &&
                                            item?.errors?.quantity
                                          }
                                          helperText={
                                            item?.errors?.quantity &&
                                            item?.errors?.quantity
                                          }
                                          onBlur={handleBlur}
                                          className={classes.rsTextField}
                                        />
                                      </Grid>
                                    )}
                                  </>
                                );
                              })}
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      className={classes.rsOrderPadGeneralInfo}
                    >
                      <Typography variant="h3" medium color="secondary">
                        Medicine details
                      </Typography>
                      <Divider />
                      <Box display={"flex"}>
                        {width < 768 ? (
                          <></>
                        ) : ( */}
                    {/* // <Grid item xs={12} sm={12} md={12}>
                          //   <FormGroup>
                          //     <FormControlLabel
                          //       className={classes.rsSurgryFormControl}
                          //       control={
                          //         <Checkbox
                          //           color="primary"
                          //           checked={showMedication}
                          //           onChange={() => {
                          //             setShowMedication(!showMedication);
                          //             setShowNoOfMedication(false);
                          //             setListOpen(false);
                          //           }}
                          //           icon={<RadioButtonUncheckedIcon />}
                          //           checkedIcon={<RadioButtonCheckedIcon />}
                          //         />
                          //       }
                          //       label="Select Specific Medications"
                          //     />
                          //   </FormGroup>
                          //   <FormGroup>
                          //     <FormControlLabel
                          //       className={classes.rsSurgryFormControl}
                          //       control={
                          //         <Checkbox
                          //           color="primary"
                          //           checked={showNoOfMedication}
                          //           onChange={() => {
                          //             setShowNoOfMedication(
                          //               !showNoOfMedication
                          //             );
                          //             setShowMedication(false);
                          //           }}
                          //           icon={<RadioButtonUncheckedIcon />}
                          //           checkedIcon={<RadioButtonCheckedIcon />}
                          //         />
                          //       }
                          //       label="Select Number Of Medications"
                          //     />
                          //   </FormGroup>
                          // </Grid>
                          <> */}
                    {/* <FormGroup>
                              <FormControlLabel
                                className={classes.rsSurgryFormControl}
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={showMedication}
                                    onChange={() => {
                                      setShowMedication(!showMedication);
                                      setShowNoOfMedication(false);
                                      setListOpen(false);
                                    }}
                                    icon={<RadioButtonUncheckedIcon />}
                                    checkedIcon={<RadioButtonCheckedIcon />}
                                  />
                                }
                                label="Select Specific Medications"
                              />
                            </FormGroup>
                            <FormGroup>
                              <FormControlLabel
                                className={classes.rsSurgryFormControl}
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={showNoOfMedication}
                                    onChange={() => {
                                      setShowNoOfMedication(
                                        !showNoOfMedication
                                      );
                                      setShowMedication(false);
                                    }}
                                    icon={<RadioButtonUncheckedIcon />}
                                    checkedIcon={<RadioButtonCheckedIcon />}
                                  />
                                }
                                label="Select Number Of Medications"
                              />
                            </FormGroup> */}
                    {/* </>
                        )}
                      </Box> */}
                    {/* {showMedication && (
                        <Box
                          className={clsx("common-table", classes.managePageH)}
                        >
                          {width < 550 ? (
                            <TableContainer className={classes.tableContainer}>
                              <Table
                                stickyHeader
                                id="quantity"
                                className={classes.rsTableBody}
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell style={{ width: "50%" }}>
                                      <div style={{ display: "flex" }}>
                                        DRUG{" "}
                                        <div
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </div>{" "}
                                      </div>
                                    </TableCell>
                                    <TableCell style={{ width: "10%" }}>
                                      QUANTITY
                                    </TableCell>
                                    <TableCell style={{ width: "5%" }}>
                                      <Box
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"space-around"}
                                      >
                                        ORDER
                                        <FormGroup
                                          className={classes.rsFromGroup}
                                        >
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                color="primary"
                                                checked={checkAllAction}
                                                onChange={(e, value) => {
                                                  const isChecked =
                                                    !checkAllAction;
                                                  setCheckAllAction(isChecked);
                                                  const _medications =
                                                    medications?.map((item) => {
                                                      item.action = isChecked;
                                                      return item;
                                                    });
                                                  setMedications(_medications);
                                                }}
                                              />
                                            }
                                          />
                                        </FormGroup>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {medications?.map((item, index) => {
                                    return (
                                      <TableRow className={classes.tableBody}>
                                        <TableCell>
                                          <DrugAutoComplete
                                            listOpen={listOpen}
                                            fullWidth
                                            disabled={!item.isNew}
                                            filterMedication={medications}
                                            className={
                                              classes.rsDrugAutoCompleteBox
                                            }
                                            value={item}
                                            onChange={(e, value) => {
                                              value = value
                                                ? {
                                                    ...value,
                                                    name: value?.label,
                                                  }
                                                : value;
                                              delete value?.label;
                                              handleDrugChange(e, index, value);
                                              handleChange("drug", value);
                                              quantityRef.current.focus();
                                            }}
                                            id={`name_${index}`}
                                            orderActionType={orderActionType}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                              <>
                                                <TextField
                                                  {...params}
                                                  inputRef={
                                                    orderActionType ===
                                                    "orderCreate"
                                                      ? medicationRef
                                                      : ""
                                                  }
                                                  id={`name_${index}`}
                                                  autoFocus={
                                                    orderActionType ===
                                                    "orderCreate"
                                                  }
                                                  label="Drug Name"
                                                  placeholder="Choose Drug"
                                                  error={
                                                    item?.errors?.name &&
                                                    item?.errors?.name
                                                  }
                                                  helperText={
                                                    item?.errors?.name &&
                                                    item?.errors?.name
                                                  }
                                                  onBlur={handleBlur}
                                                />
                                              </>
                                            )}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <TextField
                                            variant="outlined"
                                            fullWidth
                                            inputRef={quantityRef}
                                            disabled={!item.isNew}
                                            inputProps={{ maxLength: 10 }}
                                            placeholder="Quantity"
                                            label="Quantity"
                                            size="small"
                                            value={item.quantity}
                                            id={`quantity_${index}`}
                                            name={`medications[${index}]`}
                                            onChange={(e, value) => {
                                              handleChangeQuantity(e, index);
                                              handleChange(e);
                                            }}
                                            error={
                                              item?.errors?.quantity &&
                                              item?.errors?.quantity
                                            }
                                            helperText={
                                              item?.errors?.quantity &&
                                              item?.errors?.quantity
                                            }
                                            onBlur={handleBlur}
                                            className={classes.rsTextField}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <FormGroup>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  color="primary"
                                                  checked={
                                                    item?.action
                                                      ? item?.action
                                                      : false
                                                  }
                                                  onChange={(e, value) => {
                                                    handleChangeAction(
                                                      e,
                                                      index
                                                    );
                                                  }}
                                                />
                                              }
                                            />
                                          </FormGroup>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            <Table stickyHeader id="quantity">
                              <TableHead>
                                <TableRow>
                                  <TableCell style={{ width: "50%" }}>
                                    <div style={{ display: "flex" }}>
                                      DRUG{" "}
                                      <div
                                        style={{
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        *
                                      </div>{" "}
                                    </div>
                                  </TableCell>
                                  <TableCell style={{ width: "10%" }}>
                                    QUANTITY
                                  </TableCell>
                                  <TableCell style={{ width: "5%" }}>
                                    <Box
                                      display={"flex"}
                                      alignItems={"center"}
                                      justifyContent={"space-around"}
                                    >
                                      ORDER
                                      <FormGroup
                                        className={classes.rsFromGroup}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={checkAllAction}
                                              onChange={(e, value) => {
                                                const isChecked =
                                                  !checkAllAction;

                                                setCheckAllAction(isChecked);

                                                const _medications =
                                                  medications?.map((item) => {
                                                    item.action = isChecked;
                                                    return item;
                                                  });
                                                setMedications(_medications);
                                              }}
                                            />
                                          }
                                        />
                                      </FormGroup>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {medications?.map((item, index) => {
                                  return (
                                    <TableRow className={classes.tableBody}>
                                      <TableCell>
                                        <DrugAutoComplete
                                          listOpen={listOpen}
                                          fullWidth
                                          disabled={!item.isNew}
                                          filterMedication={medications}
                                          className={
                                            classes.rsDrugAutoCompleteBox
                                          }
                                          value={item}
                                          onChange={(e, value) => {
                                            value = value
                                              ? {
                                                  ...value,
                                                  name: value?.label,
                                                }
                                              : value;
                                            delete value?.label;
                                            handleDrugChange(e, index, value);
                                            handleChange("drug", value);
                                            if (value !== null) {
                                              quantityRef.current.focus();
                                            }
                                          }}
                                          id={`name_${index}`}
                                          orderActionType={orderActionType}
                                          onBlur={handleBlur}
                                          renderInput={(params) => (
                                            <>
                                              <TextField
                                                {...params}
                                                inputRef={
                                                  orderActionType ===
                                                  "orderCreate"
                                                    ? medicationRef
                                                    : ""
                                                }
                                                id={`name_${index}`}
                                                autoFocus={
                                                  orderActionType ===
                                                  "orderCreate"
                                                }
                                                label="Drug Name"
                                                placeholder="Choose Drug"
                                                error={
                                                  item?.errors?.name &&
                                                  item?.errors?.name
                                                }
                                                helperText={
                                                  item?.errors?.name &&
                                                  item?.errors?.name
                                                }
                                                onBlur={handleBlur}
                                              />
                                            </>
                                          )}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          variant="outlined"
                                          fullWidth
                                          inputRef={quantityRef}
                                          disabled={!item.isNew}
                                          inputProps={{ maxLength: 10 }}
                                          placeholder="Quantity"
                                          label="Quantity"
                                          size="small"
                                          value={
                                            item.quantity ? item.quantity : ""
                                          }
                                          id={`quantity_${index}`}
                                          name={`medications[${index}]`}
                                          onChange={(e, value) => {
                                            handleChangeQuantity(e, index);
                                            handleChange(e);
                                          }}
                                          error={
                                            item?.errors?.quantity &&
                                            item?.errors?.quantity
                                          }
                                          helperText={
                                            item?.errors?.quantity &&
                                            item?.errors?.quantity
                                          }
                                          onBlur={handleBlur}
                                          className={classes.rsTextField}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <FormGroup>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                color="primary"
                                                checked={
                                                  item?.action
                                                    ? item?.action
                                                    : false
                                                }
                                                onChange={(e, value) => {
                                                  handleChangeAction(e, index);
                                                }}
                                              />
                                            }
                                          />
                                        </FormGroup>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          )}
                        </Box>
                      )}
                      {showNoOfMedication && (
                        <Grid item xs={12} sm={12} md={12} lg={4}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Total Medication"
                            label="Total Medication"
                            size="small"
                            type="number"
                            name="number_of_medication"
                            value={values?.number_of_medication}
                            error={
                              touched?.number_of_medication &&
                              errors?.number_of_medication
                            }
                            helperText={
                              touched?.number_of_medication &&
                              errors?.number_of_medication
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            InputLabelProps={{
                              shrink:
                                query.get("actionType") === "repeatOrderPage" ||
                                showNoOfMedication
                                  ? true
                                  : false,
                            }}
                          />
                        </Grid>
                      )}
                    </Paper> */}
                  </Grid>
                </>
              )}
            </Grid>
            {showWholeForm && width < 1200 && !searchRepeatOrder?.loading && (
              <>
                <Box
                  display={"flex"}
                  margin={"0 auto"}
                  justifyContent={"center"}
                  className={classes.submitContainer}
                >
                  {/* <Grid item xs={3} sm={6} md={6} lg={6}> */}
                  <Button
                    children={
                      values?.ordering_method === "email"
                        ? "Proceed & Send Email"
                        : "Proceed"
                    }
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={createOrderPadData?.loading}
                    startIcon={
                      createOrderPadData?.loading && (
                        <CircularProgress color="white" size="20px" />
                      )
                    }
                    className={
                      values?.ordering_method !== "email"
                        ? clsx("BtnGreen", classes.rsPatientCancelBtn)
                        : clsx(
                          "BtnGreen",
                          classes.rsPatientCancelBtn,
                          classes.rsPatientCancelBtnWidth,
                        )
                    }
                  />
                  {/* </Grid> */}
                </Box>
              </>
            )}
          </form>
        </Grid>
      )}
    </>
  );
};

export default OrderToNewRx;
